import React from "react";
import GraduationCap from "../../../assets/images/fi-rr-graduation-cap.svg";
import PdfFileImage from "../../../assets/images/pdfFile.png";
import { DATE_FORMAT3 } from "../../../constants/stringConstants";
import { DateFormatter, openImageInBrowser } from "../../../functions/commons";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { isEmpty, isNil } from "lodash";
import { Image } from "antd";

function ProfileCompletionEducationDiv({degree,onEdit}) {
  console.log({degree})
 
  return (
    <> 
    
      <div className="c1-education-div__logo-text-img" >
        <img src={GraduationCap} alt="graduation-cap" /> 

        <div className="c1ed-logo-text-img__text-img">

<div style={{display:'flex'}}>
          {degree.institute&&<h3>{degree.nameOfDegree}</h3>
          }
            <div onClick={()=>onEdit(degree)} className="edit_icon" style={{marginLeft:'40px'}}><ModeEditOutlineOutlinedIcon style={{height:'20px',width:'20px'}}/> </div>

          </div> 
       {degree.institute&&   <h4>{degree.institute}</h4>
       }
    <p>
            {`${DateFormatter(degree.from,DATE_FORMAT3)} - ${DateFormatter(degree.to,DATE_FORMAT3)}`}
          </p>
          {!isNil(degree.degreeImage)&&!isEmpty(degree.degreeImage) && <Image src={PdfFileImage} style={{height:'70px',width:'70px'}}  preview={false}
          onClick={()=>openImageInBrowser(degree.degreeImage)}
          />}

        </div>

      </div>

    </>
  );
}

export default ProfileCompletionEducationDiv;
